import { GRID_NODE_TYPES } from 'layout-data-lib/GridLayoutDataTree/constants';
import { DND_GRID_AREA_MODULE_ELEMENT_ID_PREFIX, DND_GRID_AREA_SECTION_CONTENT_CLASS_NAME_PREFIX, GRID_DATA_ATTRIBUTE_NODE_MAP } from './constants';
const getDndAreaDataHsId = id => {
  return `[${GRID_DATA_ATTRIBUTE_NODE_MAP[GRID_NODE_TYPES.ROOT]}="${id}"]`;
};
export const getGridNodeElementSelector = node => {
  if (node.isModule()) {
    return `[id="${DND_GRID_AREA_MODULE_ELEMENT_ID_PREFIX}${node.getId()}"]`;
  }
  return `[${GRID_DATA_ATTRIBUTE_NODE_MAP[node.getType()]}="${node.getId()}"]`;
};
export const getSectionContentElementSelector = node => {
  return `.${DND_GRID_AREA_SECTION_CONTENT_CLASS_NAME_PREFIX}${node.getId()}-content`;
};
export const getDndAreaElement = id => {
  const dndAreaElement = document.querySelector(getDndAreaDataHsId(id));
  if (!dndAreaElement) {
    throw new Error(`Could not find DnD area element with id ${id}`);
  }
  return dndAreaElement;
};
export const getGridNodeElement = (node, parentElement = document.body) => {
  const gridContentElement = parentElement.querySelector(getGridNodeElementSelector(node));
  if (!gridContentElement) {
    console.warn(`Could not find grid content element of ${node.getType()} with id ${node.getId()}`);
  }
  return gridContentElement;
};
export const getGridLayoutElement = (node, parentElement) => {
  // TODO: Add delegated bounds support
  return [getGridNodeElement(node, parentElement)];
};
export const getSectionElementById = (id, parentElement = document.body) => {
  return parentElement === null || parentElement === void 0 ? void 0 : parentElement.querySelector(`[${GRID_DATA_ATTRIBUTE_NODE_MAP[GRID_NODE_TYPES.SECTION]}="${id}"]`);
};
export const getContainerElementById = (id, parentElement = document.body) => {
  return parentElement === null || parentElement === void 0 ? void 0 : parentElement.querySelector(`[${GRID_DATA_ATTRIBUTE_NODE_MAP[GRID_NODE_TYPES.CONTAINER]}="${id}"]`);
};
export const getModuleElementById = (id, parentElement = document.body) => {
  return parentElement === null || parentElement === void 0 ? void 0 : parentElement.querySelector(`[id="${DND_GRID_AREA_MODULE_ELEMENT_ID_PREFIX}${id}"]`);
};